import { request, orgBase } from '@/api/http'
import type { HndlSimulateRequest, HndlSimulateResult } from '@/api/types'

export const hndlApi = {
  simulate(orgId: string, body: HndlSimulateRequest): Promise<HndlSimulateResult> {
    return request(`${orgBase(orgId)}/hndl/simulate`, { method: 'POST', body: JSON.stringify(body) })
  },
}
